import React, { useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { FaSearch, FaHeart, FaImage, FaUser } from 'react-icons/fa';
import { useAuth } from '../context/AuthContext';
import { useGallery } from '../context/GalleryContext';
import './Navbar.css';

const Navbar = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const { searchImages } = useGallery();
  const { currentUser } = useAuth();
  const location = useLocation();

  // Hide search bar on home page since it has a hero search
  const showSearch = location.pathname !== '/';

  const handleSearch = (e: any) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      searchImages(searchQuery);
    }
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          <h1>Opus</h1>
        </Link>

        {showSearch && (
          <div className="navbar-search">
            <form onSubmit={handleSearch}>
              <button type="submit" className="search-button">
                <FaSearch />
              </button>
              <input
                type="text"
                placeholder="Search..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="search-input"
              />
            </form>
          </div>
        )}

        <div className="navbar-links">
          <NavLink to="/" className={({ isActive }) => isActive ? 'active' : ''}>
            <FaImage /> <span>Gallery</span>
          </NavLink>
          {currentUser ? (
            <>
              <NavLink to="/favorites" className={({ isActive }) => isActive ? 'active' : ''}>
                <FaHeart /> <span>Favorites</span>
              </NavLink>
              <NavLink to="/dashboard" className={({ isActive }) => isActive ? 'active' : ''}>
                <FaUser /> <span>Dashboard</span>
              </NavLink>
            </>
          ) : (
            <NavLink to="/login" className={({ isActive }) => isActive ? 'active' : ''}>
              <FaUser /> <span>Login</span>
            </NavLink>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar; 